import React, { useState } from 'react';
import './RecentSearches.css';

// Show a single quiet row by default; the rest opens behind an explicit,
// always-visible "+N" toggle so a long history can't stack rows of pills.
const VISIBLE_COUNT = 5;

const RecentSearches = ({ history, onSelect, onRemove, onClear }) => {
  const [expanded, setExpanded] = useState(false);

  if (!history || history.length === 0) return null;

  const formatLabel = (item) => {
    if (item.address) return item.address;
    if (item.gush && item.helka) return `גוש ${item.gush} חלקה ${item.helka}`;
    return 'חיפוש לא ידוע';
  };

  const visible = expanded ? history : history.slice(0, VISIBLE_COUNT);
  const hiddenCount = history.length - VISIBLE_COUNT;

  return (
    <div className="recent-searches">
      <span className="recent-searches-title">חיפושים אחרונים:</span>
      <div className="recent-searches-list">
        {visible.map((item) => (
          <div key={item.timestamp} className="recent-search-chip">
            <button
              type="button"
              className="recent-search-chip-btn"
              onClick={() => onSelect(item)}
              title={formatLabel(item)}
            >
              <span className="recent-search-chip-text">{formatLabel(item)}</span>
              {item.municipality && item.searchMode === 'parcel' && (
                <span className="recent-search-chip-meta">{item.municipality}</span>
              )}
            </button>
            <button
              type="button"
              className="recent-search-chip-remove"
              onClick={(e) => { e.stopPropagation(); onRemove(item.timestamp); }}
              title="הסר"
              aria-label="הסר מהיסטוריה"
            >
              <i className="fi fi-rr-cross-small"></i>
            </button>
          </div>
        ))}
        {hiddenCount > 0 && (
          <button
            type="button"
            className="recent-searches-more"
            onClick={() => setExpanded((v) => !v)}
            aria-expanded={expanded}
          >
            {expanded ? 'הצג פחות' : `עוד ${hiddenCount}+`}
          </button>
        )}
      </div>
      <button
        type="button"
        className="recent-searches-clear"
        onClick={onClear}
        title="נקה היסטוריה"
      >
        נקה הכל
      </button>
    </div>
  );
};

export default RecentSearches;
